import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import React, { useState } from "react";
import { Button } from "rsuite";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";
import { useNavigate } from "react-router-dom";
import { Trash } from "@rsuite/icons";

const CommercialScheduleItemBulkAction = ({
  commercialScheduleData,
  checkedKeys,
  setCheckedKeys,
  onDeleteItems,
  onCopyItems,
  enableBulkAction = ["delete", "add"],
  ...props
}: {
  commercialScheduleData: any;
  checkedKeys: any;
  setCheckedKeys: Function;
  onDeleteItems?: Function;
  onCopyItems?: Function;
  enableBulkAction?: string[];
}) => {
  const { t } = useTranslation();
  const [openBulkActionNoSelectionModal, setOpenBulkActionNoSelectionModal] =
    useState(false);
  const [openBulkActionModal, setOpenBulkActionModal] = useState(false);
  const [bulkActionMessage, setBulkActionMessage] = useState("");
  const [bulkActionTitle, setBulkActionTitle] = useState("");
  const ecryptedCommercialScheduleId = encryptUrl(
    `${commercialScheduleData.id}`
  );

  const addItemsToCommercialScheduleLink =
    ContentRoutes.ADD_ITEMS_TO_COMMERCIAL_SCHEDULE.replace(
      ":id",
      ecryptedCommercialScheduleId.toString()
    );
  const navigate = useNavigate();

  function handleAddItemsToCommercialScheduleAction() {
    navigate(`${addItemsToCommercialScheduleLink}`);
  }

  function bulkDelete() {
    if (checkedKeys.length === 0) {
      setBulkActionMessage(t("PLEASE_SELECT_RECORD_TO_ACTION"));
      setOpenBulkActionNoSelectionModal(true);
      return true;
    }
    setOpenBulkActionModal(true);

    setBulkActionMessage(
      t("CONFIRM_ACTION", {
        action: t("DELETE").toLowerCase(),
        entity: t("ITEM").toLowerCase(),
      })
    );
    setBulkActionTitle(
      t("CONFIRM_ACTION_TITLE", {
        action: t("DELETE").toLowerCase(),
      })
    );
  }

  function copyItems() {
    if (checkedKeys.length === 0) {
      setBulkActionMessage(t("PLEASE_SELECT_RECORD_TO_ACTION"));
      setOpenBulkActionNoSelectionModal(true);
      return false;
    }
    // if (isEmptyVal(playForDay)) {
    //   setBulkActionMessage(
    //     t("PLEASE_SELECT_FIELD", {
    //       field: t("PLAY") + " " + t("FOR") + " " + t("DAY"),
    //     })
    //   );
    //   setOpenBulkActionNoSelectionModal(true);
    //   return false;
    // }
    // if (isEmptyVal(startHour)) {
    //   setBulkActionMessage(
    //     t("PLEASE_SELECT_FIELD", { field: t("START") + " " + t("HOUR") })
    //   );
    //   setOpenBulkActionNoSelectionModal(true);
    //   return false;
    // }
    onCopyItems && onCopyItems();
  }

  return (
    <div className="commercial-schedule-item-action">
      {UtilityServices.hasPermission("delete-item") && (
        <div className="commercial-schedule-item-action-toolbar">
          <div className="commercial-schedule-item-action-title">
            Bulk Actions
          </div>
          <div className="commercial-schedule-item-action-buttons">
            {enableBulkAction.includes("delete") && (
              <Button
                className="commercial-schedule-item-bulk-btn commercial-schedule-item-bulk-btn-delete"
                appearance="ghost"
                onClick={bulkDelete}
                startIcon={<Trash />}
                title={t("DELETE") + " " + t("ITEMS")}
              >
                {t("DELETE")} {t("ITEMS")}
              </Button>
            )}
            {enableBulkAction.includes("add") && (
              <Button
                className="commercial-schedule-item-bulk-btn commercial-schedule-item-bulk-btn-add"
                appearance="ghost"
                onClick={handleAddItemsToCommercialScheduleAction}
                title={t("ADD") + " " + t("ITEMS")}
                startIcon={
                  <span className="commercial-schedule-item-plus-icon">+</span>
                }
              >
                {t("ADD")} {commercialScheduleData.total_items > 0 && t("MORE")}{" "}
                {t("ITEMS")}
              </Button>
            )}
            {enableBulkAction.includes("copy") && (
              <Button
                className="commercial-schedule-item-bulk-btn"
                appearance="ghost"
                onClick={copyItems}
                title={t("COPY") + " " + t("ITEMS")}
              >
                {t("COPY")}
              </Button>
            )}
          </div>
        </div>
      )}
      <AlertModal
        open={openBulkActionNoSelectionModal}
        handleClose={(e: any) => {
          if (e) {
            setOpenBulkActionNoSelectionModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={t("PLEASE_SELECT")}
        cancelButton={false}
      />

      <AlertModal
        open={openBulkActionModal}
        handleClose={(e: any) => {
          if (e == true) {
            onDeleteItems();
            setOpenBulkActionModal(false);
          } else {
            setOpenBulkActionModal(false);
          }
        }}
        displayText={bulkActionMessage}
        modalTitle={bulkActionTitle}
      />
    </div>
  );
};

export default CommercialScheduleItemBulkAction;
